import module from 'viaticos/module.js'

export const schema = {
  colaboradores: {
    importe: 'number',
    comision_importe: 'number',
    comision_porcentaje: 'number',
    neto: 'number',
    incapacidades: {
      dias_pagados: 'number',
      importe: 'number',
    },
    total_prestamos: 'number',
    total_servicios: 'number',
    deducciones: {
      dias: 'number',
      exento: 'number',
      gravado: 'number',
      horas: 'number',
      id_concepto: 'number',
      importe: 'number',
      impuesto_estatal: 'number',
    },
    percepciones: {
      dias: 'number',
      exento: 'number',
      gravado: 'number',
      horas: 'number',
      id_concepto: 'number',
      importe: 'number',
      impuesto_estatal: 'number',
    },
    acumulado: {
      anual: {
        id_concepto: 'number',
        importe: 'number',
        gravado: 'number',
      },
      mensual: {
        id_concepto: 'number',
        importe: 'number',
        gravado: 'number',
      },
    },
    config: {
      absorber_cuota_obrera: 'number',
      absorber_cuota_patronal: 'number',
      absorber_impuesto_estatal: 'number',
      absorber_isr: 'number',
      calculo_mensual_acumulado: 'boolean',
      aguinaldo_exento: 'number',
      asimilados_acumulado: 'number',
      carga_social_pendiente: 'number',
      clase_prima_riesgo: 'number',
      cobro_carga_social: 'boolean',
      dias_carga_social: 'number',
      dias_pendientes_incapacidad: 'number',
      estrategiaId: 'number',
      fecha_baja: 'date',
      fecha_imss_alta: 'date',
      fecha_imss_baja: 'date',
      fecha_ingreso: 'date',
      fecha_suspension: 'date',
      fonacot_pendiente: 'number',
      fonacot_pendiente_saldo: 'number',
      id_estado: 'number',
      id_regimen_fiscal: 'number',
      id_tipo_nomina: 'number',
      id_tipo_pension_alimenticia: 'number',
      infonavit_deduccion_valor: 'number',
      infonavit_pendiente: 'number',
      infonavit_pendiente_saldo: 'number',
      isr_acumulado: 'number',
      prima_riesgo: 'number',
      prima_vacacional_exento: 'number',
      reparto_utilidades_exento: 'number',
      salario_diario: 'number',
      salario_diario_integrado: 'number',
      salario_mensual: 'number',
      subsidio_acumulado: 'number',
      pension_alimenticia_valor: 'number',
      tarifa: 'number',
      ultima_nomina_ordinaria_calculada: 'boolean',
    },
  },
  configuracion: {
    calcular_aguinaldo: 'boolean',
    calcular_viaticos: 'boolean',
    cobrar_impuesto_estatal: 'boolean',
    complemento_aguinaldo: 'number',
    contiene_viaticos: 'boolean',
    fecha: 'date',
    fecha_final: 'date',
    fecha_inicial: 'date',
    fecha_pago: 'date',
    fondo_ahorro_porcentaje: 'number',
    id_regimen_fiscal: 'number',
    id_tipo_nomina: 'number',
    id_metodo_calculo_comision: 'number',
    id_metodo_calculo_suministro: 'number',
    id_tipo_calculo: 'number',
    impuesto_estatal: 'number',
    iva_porcentaje: 'number',
    piramidar: 'boolean',
    proratear_subsidio: 'boolean',
    salario_minimo: 'number',
    subsidio_mensual: 'number',
    uma_importe: 'number',
    uma_valor_unidad_mixta: 'number',
    no_deducible: 'boolean',
    omitir_carga_social_pendiente: 'boolean',
  },
}

export class ViaticosConfiguracionService {
  constructor ($http) {
    this.$http = $http
  }

  get (solicitudId, viaticoId) {
    return this.$http.get('api/viaticos/viaticos/configuracion', {
      params: {
        solicitud_id: solicitudId,
        viatico_id: viaticoId,
      },
      schema,
    })
  }
}

module.service('ViaticosConfiguracionService', ViaticosConfiguracionService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Configuracion.js